import type { MRT_ColumnDef } from "material-react-table";
import type { AdminCampaignDto } from "Infrastructure/Api/Api";
import { formatDate } from "Utils/DateUtils";
import { DATE_FILTER_COLUMN_MIN_SIZE } from "Hooks/useServerTable";
import { Resources, type TFunction } from "Translations/Resources";
import { IconButton, Tooltip, Box } from "@mui/material";
import RestoreIcon from "@mui/icons-material/Restore";
import { createSharedCampaignColumns } from "../sharedCampaignColumns";

const RESOURCES = Resources.Admin.Campaigns;

export const createColumns = (
  t: TFunction,
  onRestore: (id: number) => void,
): Array<MRT_ColumnDef<AdminCampaignDto>> => [
  ...createSharedCampaignColumns(t),

  {
    accessorKey: "dateUpdated",
    header: t(RESOURCES.Table.Deleted),
    size: DATE_FILTER_COLUMN_MIN_SIZE,
    filterVariant: "date",
    Cell: ({ row }) =>
      row.original.dateUpdated ? formatDate(row.original.dateUpdated) : "—",
  },
  {
    accessorKey: "actions",
    header: t(RESOURCES.Table.Actions),
    size: 100,
    enableColumnFilter: false,
    enableSorting: false,
    Cell: ({ row }) => (
      <Box display="flex" gap={1}>
        <Tooltip title={t(RESOURCES.Table.Restore)}>
          <IconButton
            onClick={() => onRestore(row.original.campaignID)}
            size="small"
            color="primary"
          >
            <RestoreIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
    ),
  },
];
